export var CreditLimitIncreaseInput;
(function (CreditLimitIncreaseInput) {
    CreditLimitIncreaseInput["desiredAmount"] = "desiredAmount";
    CreditLimitIncreaseInput["annualNetIncome"] = "annualNetIncome";
})(CreditLimitIncreaseInput || (CreditLimitIncreaseInput = {}));
export const initialCreditLimitIncreaseModalState = {
    desiredAmount: { value: '', errorMessage: '' },
    annualNetIncome: { value: '', errorMessage: '' }
};
